import type { ToastState } from "../../hooks/useToast";

interface ToastProps {
  toast: ToastState | null;
}

export function Toast({ toast }: ToastProps) {
  if (!toast) return null;

  return (
    <div
      className={`fixed bottom-4 right-4 z-50 rounded-md px-4 py-3 text-sm shadow-lg ${
        toast.type === "success"
          ? "bg-green-50 border border-green-200 text-green-800"
          : toast.type === "info"
            ? "bg-blue-50 border border-blue-200 text-blue-800"
            : "bg-destructive/10 border border-destructive/20 text-destructive"
      }`}
      role={toast.type === "error" ? "alert" : "status"}
    >
      {toast.message}
    </div>
  );
}
